module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/high-capacity-transport-reward-100.25942c12.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/high-capacity-transport-reward-100.png
// module id = 3784
// module chunks = 11